/**
 * Verifica se um elemento está contido na lista com base na chave passada como parâmetro.
 * @param list A lista de elementos
 * @param item O elemento que será verificado
 * @param key A chave que será usada para comparar os elementos
 * @returns boolean
 */
export function contemNaLista<T>(list: T[], item: T, key: keyof T) {
  return list.some((listItem) => listItem[key] === item[key]);
}

/**
 * Adiciona ou remove um elemento da lista com base na existência do elemento na lista.
 * @param list A lista de elementos
 * @param item O elemento que será adicionado ou removido
 * @param key A chave que será usada para comparar os elementos
 * @returns A lista atualizada
 */
export function toggleSelecionado<T>(list: T[], item: T, key: keyof T) {
  if (contemNaLista(list, item, key)) {
    return list.filter((listItem) => listItem[key] !== item[key]);
  }
  return [...list, item];
}

/**
 *  Seleciona ou deseleciona todos os elementos da lista com base no estado atual dos elementos.
 * @param items Lista de elementos
 * @param itemsSelecionados Lista de elementos selecionados
 * @param key A chave que será usada para comparar os elementos
 */
export function selecionarTodos<T>(
  items: T[],
  itemsSelecionados: T[],
  key: keyof T
): T[] {
  const deveSelecionar = !isTodosSelecionados(items, itemsSelecionados, key);

  if (deveSelecionar) {
    for (const item of items) {
      if (!contemNaLista(itemsSelecionados, item, key)) {
        itemsSelecionados.push(item);
      }
    }
    return itemsSelecionados;
  }

  return itemsSelecionados.filter(
    (itemSelecionado) => !contemNaLista(items, itemSelecionado, key)
  );
}

/**
 * Retorna se todos os itens estão selecionados com base na key passada como parâmetro
 * @param itemsTotais A lista completa de elementos
 * @param itemsSelecionados A lista de elementos selecionados
 * @param key A chave que será usada para comparar os elementos
 * @returns boolean
 */
export function isTodosSelecionados<T>(
  itemsTotais: T[],
  itemsSelecionados: T[],
  key: keyof T
) {
  return itemsTotais.every((item) =>
    itemsSelecionados.some(
      (itemSelecionado) => item[key] === itemSelecionado[key]
    )
  );
}
